module.exports = __webpack_public_path__ + "static/sponsor-cccdc4d327035c33c2a921b3d35efdf9.svg";